var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/submissions/components/SubmissionForm/SubmissionFormEpisodesItem.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionFormEpisodesItem.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data", "isRequired"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("isRequired", Object.prototype.hasOwnProperty.call(kwargs, "isRequired") ? kwargs["isRequired"] : true);var t_5 = "";t_5 += "\n    <div class=\"SubmissionFormEpisodesItem\">\n        <div class=\"SubmissionFormElement-form SubmissionFormElement-form--border\">\n\n            <input type=\"hidden\" value=\"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id")) {
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id"), env.opts.autoescape);
;
}
t_5 += "\" name=\"id\">\n            <input type=\"hidden\" value=\"\" name=\"_id\">\n\n            <div class=\"SubmissionFormElement-inputLine\">\n                <div class=\"SubmissionFormElement-inputName ";
if(runtime.contextOrFrameLookup(context, frame, "isRequired")) {
t_5 += "SubmissionFormElement-inputName--required";
;
}
t_5 += "\">EPISODE NUMBER AND TITLE</div>\n                <div class=\"SubmissionFormElement-inputWrapper\">\n                    <input type=\"text\" value=\"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"title")) {
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"title"), env.opts.autoescape);
;
}
t_5 += "\" name=\"title\" class=\"SubmissionFormElement-input\">\n                </div>\n            </div>\n\n            <div class=\"SubmissionFormElement-inputLine\">\n                <div class=\"SubmissionFormElement-inputName  ";
if(runtime.contextOrFrameLookup(context, frame, "isRequired")) {
t_5 += "SubmissionFormElement-inputName--required";
;
}
t_5 += "\">AIR DATE</div>\n                <div class=\"SubmissionFormElement-inputWrapper\">\n                    <div class=\"SubmissionFormEpisodesItem-date ";
if((!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"date"))) {
t_5 += "SubmissionFormEpisodesItem-date--empty";
;
}
t_5 += "\" data-date=\"";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"date"))) {
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"date"), env.opts.autoescape);
;
}
t_5 += "\"><span>";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"date"))) {
t_5 += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"date"),"%m/%d/%y"), env.opts.autoescape);
;
}
else {
t_5 += "MM/DD/YY";
;
}
t_5 += "</span></div>\n                </div>\n            </div>\n\n            <div class=\"SubmissionFormElement-delete\">\n                <div class=\"SubmissionFormElement-deleteItem\"></div>\n                <div class=\"SubmissionFormElement-deleteItem\"></div>\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("SubmissionFormEpisodesItem");
context.setVariable("SubmissionFormEpisodesItem", macro_t_4);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/submissions/components/SubmissionForm/SubmissionFormEpisodesItem.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormEpisodesItem.jinja
// module id = 22
// module chunks = 0